import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withKeys as _withKeys, renderSlot as _renderSlot, withModifiers as _withModifiers, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b543ad38"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bx bx-filter" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { ref, onMounted } from 'vue';
import { createPopper } from '@popperjs/core';
import Btn from '../Btn/Btn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomFilters',
  props: {
    buttonLabel: {}
  },
  emits: ['applyFilters', 'closeFiltersDropdown', 'openFiltersDropdown'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const popper = ref();
const toggleDropdownButton = ref<HTMLButtonElement | null>(null);
const filtersDropdown = ref<HTMLDivElement | null>(null);
const isDropdownOpen = ref(false);

onMounted(() => {
	popper.value = createPopper(toggleDropdownButton.value, filtersDropdown.value, {
		placement: 'bottom',
		modifiers: [
			{
				name: 'offset',
				options: {
					offset: [0, 8],
				},
			},
		],
	});
});

function toggleDropdown() {
	if (isDropdownOpen.value) {
		hideDropdown();
		return;
	}
	// popper uses data-show attribute
	filtersDropdown.value.setAttribute('data-show', '');
	popper.value.update(); // Get correct position when showing on screen
	isDropdownOpen.value = true;
	// Notify parent to handle the state of slotted filters
	emit('openFiltersDropdown');
}

function hideDropdown() {
	filtersDropdown.value.removeAttribute('data-show');
	isDropdownOpen.value = false;
	// Notify parent to handle the state of slotted filters
	emit('closeFiltersDropdown');
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    "data-test": "custom-filters",
    onKeydown: _withKeys(hideDropdown, ["esc"])
  }, [
    _createElementVNode("button", {
      ref_key: "toggleDropdownButton",
      ref: toggleDropdownButton,
      "data-test": "toggle-dropdown-button",
      name: "Show filters button",
      title: "Show filters",
      "aria-controls": "filtersDropdown",
      "aria-expanded": isDropdownOpen.value,
      "aria-label": "Show filters button",
      class: "show-filters-button icon-button",
      onMousedown: toggleDropdown,
      onKeydown: _withKeys(toggleDropdown, ["enter"])
    }, _hoisted_3, 40, _hoisted_1),
    _createElementVNode("div", {
      ref_key: "filtersDropdown",
      ref: filtersDropdown,
      id: "filtersDropdown",
      "data-test": "filters-dropdown",
      class: "filters-dropdown bg-white rounded-2 shadow-dropdown"
    }, [
      _renderSlot(_ctx.$slots, "filters"),
      _createVNode(Btn, {
        label: _ctx.buttonLabel ?? 'Apply filters',
        variant: "secondary",
        size: "small",
        class: "m-2",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('applyFilters')), ["stop"]))
      }, null, 8, ["label"])
    ], 512)
  ], 32)), [
    [_directive_click_outside, hideDropdown]
  ])
}
}

})